import { useAPI } from "@sqreem-frontend/sqapp";
import store from "../store/store";
import { setOneInsightPerm } from "../store/components/Main.slice";

// eslint-disable-next-line react-hooks/rules-of-hooks
const SqAPI = useAPI();

class MainServices {
  constructor() {
    this._information = null;
  }

  setInfo(info) {
    this._information = info;
  }
  getPermission() {
    const { dispatch } = store;
    const url = `https://api-3.sqreemtech.com/iamsession/getpermission`;
    const reqBody = {
      idUsergroup: this._information?.signedUsergroup?.usergroupId,
      idUser: this._information?.id,
      type: "oiv6",
    };

    return SqAPI.get(url, reqBody).apiPromise.then(({ data: { data } }) => {
      dispatch(
        setOneInsightPerm(
          Object.values(data ?? {}).map(({ code }) => code.toLowerCase())
        )
      );
    });
  }
}
export default new MainServices();
